// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__12GpZ","label":"CategoryService_label__3lEVD","location":"CategoryService_location__bVHTm"};